import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, Badge, UncontrolledTooltip, FormGroup,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';
// import parse from 'html-react-parser';

import SupplierModal from './SupplierModal';
import Suppliers from '../../../services/SuppliersService';
import CommonService from '../../../services/CommonService';
import PaymentListsModal from '../../../shared/modals/PaymentListsModal';
import AddPaymentModal from './AddPaymentModal';
import global from '../../../global';

class SupplierLists extends Component {
  constructor(props) {
    super(props);
    this.userData = JSON.parse(localStorage.getItem('userData'));
    this.state = {
      realList: [],
      list: [],
      modal: false,
      title: 'Supplier',
      formdata: {
        supplierName: '',
        contactNumber: '',
        address: '',
        currentBalance: '',
      },
    };
    this.isLoading = false;
    this.toggleModal = this.toggleModal.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.editToggle = this.editToggle.bind(this);
    this.userdata = JSON.parse(localStorage.getItem('userData'));
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadSuppliers();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  async onLoadSuppliers() {
    await Suppliers.getSuppliers().then((response) => {
      const result = response;
      this.setState({ list: result, realList: result });
      this.handleClick();
      this.isLoading = false;
    }).catch((error) => {
      console.log(error);
    });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formdata: { ...prevState.formdata, [name]: value },
    }));
  }

  addToggle() {
    this.toggleModal('Add');
    this.executeModal = 'addsupplier';
    this.setState(prevState => ({
      formdata: {
        ...prevState.formdata,
        supplierName: '',
        contactNumber: '',
        address: '',
        currentBalance: '',
        executeModal: this.executeModal,
      },
    }));
    this.handleSubmit = (e) => { this.addSubmitForm(e); };
  }

  addSubmitForm(e) {
    e.preventDefault();
    const { formdata } = this.state;
    formdata.added_by = this.userData.user_id;

    if (formdata.supplierName) {
      // add supplier
      Suppliers.addSupplier(formdata).then((result) => {
        if (result) {
          if (result === true) {
            this.onLoadSuppliers();
            this.setState({ errorMsg: '', modal: false });

            swal({
              title: 'New Supplier was added!',
              text: 'Would you like to add a new supplier?',
              icon: 'success',
              closeOnClickOutside: false,
              buttons: {
                no: 'NOPE',
                yes: 'ADD NEW',
              },
            }).then((name) => {
              name = name.toLowerCase();

              if (name === 'yes') {
                this.addToggle();
              }
            });
          } else {
            this.setState({ errorMsg: result });
          }
        } else {
          swal('', 'Something went wrong!', 'error');
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required field(s) are empty.' });
    }
  }

  handleClick(event = '') {
    const selected = event !== '' ? event.selected + 1 : 1;
    const { realList } = this.state;

    const lastPost = selected * 10;
    const firstPost = lastPost - 10;

    const newList = realList.slice(firstPost, lastPost);
    this.setState({ list: newList });
 }

  editToggle(id) {
    this.toggleModal('Edit');
    this.executeModal = 'editsupplier';
    this.setState({ errorMsg: '' });
    // get location info
    Suppliers.getInfo(id).then((result) => {
      if (result) {
        this.setState({
          formdata: {
            supplierName: result.supplier_name,
            contactNumber: result.supplier_phone,
            address: result.supplier_address,
            currentBalance: result.balance,
          },
        });
      }
    }).catch((error) => {
      console.log(error);
    });
    // submit form
    this.handleSubmit = (e) => { this.editSubmitForm(e, id); };
  }

  editSubmitForm(e, id) {
    e.preventDefault();
    const { formdata } = this.state;
    formdata.id = id;

    if (formdata.supplierName) {
      Suppliers.editSupplier(formdata).then((result) => {
        if (result === true) {
          this.onLoadSuppliers();
          this.setState({ modal: false });

          swal('', 'Successfully updated product name!', 'success');
        } else {
          this.setState({ errorMsg: result });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  paymentToggle(e, supplierId, balance = 0) {
    e.preventDefault();
    this.toggleModal();
    this.executeModal = 'addpayment';
    this.setState({
      formdata: {
        amount: 0,
      },
      balance,
      errorMsg: '',
    });
    this.handleSubmit = (ev) => { this.submitPayment(ev, supplierId, balance); };
  }

  async submitPayment(e, supplierId, balance = 0) {
    e.preventDefault();
    const { formdata } = this.state;
    const amount = formdata.amount ? parseFloat(formdata.amount, 10) : 0;
    balance = parseFloat(balance, 10);
    formdata.supplier = supplierId;
    formdata.balance = balance;
    formdata.addedBy = this.userdata.user_id;

    if (formdata.amount) {
      if (amount > balance) {
        this.setState({ errorMsg: 'Enter amount less than or equal to balance.' });
      } else {
        const response = await CommonService.insertData('addsupplierpayment', formdata);
        if (response === true) {
          this.onLoadSuppliers();
          this.setState({ errorMsg: '', modal: false });
        } else {
          this.setState({ errorMsg: response });
        }
      }
    } else {
      this.setState({ errorMsg: 'Required field is empty.' });
    }
  }

  viewPaymentList(e, supplierId) {
    e.preventDefault();
    this.executeModal = 'viewpayment';
    this.toggleModal();
    this.setState({ supplierId });
  }

  updateSupplierStatus(e, id, status) {
    e.preventDefault();
    const statusTxt = status === 1 ? 'activate' : status === 2 ? 'remove' : 'deactivate';
    console.log(status);
    swal({
      title: 'Confirmation',
      text: `Are you sure you want to ${statusTxt} this supplier?`,
      icon: 'warning',
      closeOnClickOutside: false,
      buttons: {
        yes: 'YES',
        no: 'NO',
      },
    }).then((name) => {
      name = name.toLowerCase();

      if (name === 'yes') {
        Suppliers.updateSupplierStatus(id, status).then((result) => {
          if (result === true) {
            this.onLoadSuppliers();
            swal('', `Successfully ${statusTxt}d suppler!`, 'success');
          } else {
            swal('', 'Something went wrong!', 'error');
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    });
  }

  toggleModal(text = '') {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (text) {
      this.setState({ title: text });
    }
  }

  render() {
    const {
      list, modal, title, formdata, errorMsg, balance, supplierId, realList,
    } = this.state;
    const { statusType } = global;

    return (
      <Col md={12}>
        {
          this.executeModal === 'addpayment' ? (
            <AddPaymentModal
              modal={modal}
              toggle={this.toggleModal}
              formdata={formdata}
              handleChange={this.handleChange}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
              balance={balance}
            />
          ) : this.executeModal === 'viewpayment' ? (
            <PaymentListsModal
              modal={modal}
              toggle={this.toggleModal}
              id={supplierId}
              identifier="supplier"
            />
          ) : (
            <SupplierModal
              title={`${title} Supplier`}
              modal={modal}
              toggle={this.toggleModal}
              handleChange={this.handleChange}
              handleSubmit={this.handleSubmit}
              postValue={formdata}
              errorMsg={errorMsg}
            />
          )
        }
        <Card className="panel panel--primary do_magic" id="users_table">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">SUPPLIERS</h5>

              <div className="panel__btns">
                <Button onClick={this.addToggle} className="rounded text-white" size="sm" outline><i className="fa fa-parachute-box m-r-4" /> <span>Add Supplier</span></Button>
              </div>
            </div>
            <div className="panel__content">
              <Table responsive striped className="doResTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Contact Number</th>
                    <th>Address</th>
                    <th className="text-center">Balance</th>
                    <th width="20%" className="text-center">Status</th>
                    <th width="10%" className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item, i) => {
                      item.status = parseInt(item.status, 10);
                      let statusColor = 'success';
                      let btnColor = 'danger';
                      let btnIcon = 'times';
                      let statusText = 'Deactivate';
                      if (item.status === 1) {
                        statusColor = 'danger';
                        btnColor = 'success';
                        btnIcon = 'check';
                        statusText = 'Activate';
                      }
                      const itemBalance = global.parseToNumber(item.balance);

                      return (
                        <tr key={item.supplier_id}>
                          <td>{item.supplier_name}</td>
                          <td>{item.supplier_phone ? item.supplier_phone : '-'}</td>
                          <td className="white-space-pre-wrap">{item.supplier_address ? item.supplier_address : '-'}</td>
                          <td className="text-red text-center">{ itemBalance > 0 ? <span>&#x20B1; {global.numberFormat(itemBalance)}</span> : '-' }</td>
                          <td className="text-center"><Badge color={statusColor}>{statusType[item.status]}</Badge></td>
                          <td className="text-center ab">
                            {
                              /* Edit */
                              item.status === 0 && (
                                <>
                                <Button color="primary" className="btn-xs" onClick={() => this.editToggle(item.supplier_id)} id={`suplreditbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                                <UncontrolledTooltip placement="bottom" target={`suplreditbtn${i + 1}`}>Edit</UncontrolledTooltip>
                                </>
                              )
                            }
                            {
                              /* Add Payment */
                              parseFloat(item.balance, 10) > 0 && (
                                <>
                                   <Button color="success" className="btn-xs" onClick={e => this.paymentToggle(e, item.supplier_id, item.balance)} id={`paymentbtn${i + 1}`} outline><span className="fa fa-money-bill-alt" /></Button>
                                   <UncontrolledTooltip placement="bottom" target={`paymentbtn${i + 1}`}>Add Payment</UncontrolledTooltip>
                                </>
                              )
                            }

                            {/* Activate / Deactivate */}
                            <Button color="warning" className="btn-xs" id={`viewpayments${i + 1}`} onClick={e => this.viewPaymentList(e, item.supplier_id)} outline><span className="fa fa-eye" /></Button>
                            <UncontrolledTooltip placement="bottom" target={`viewpayments${i + 1}`}>View Payment Lists</UncontrolledTooltip>

                            {/* Activate / Deactivate */}
                            <Button color={btnColor} className="btn-xs" onClick={e => this.updateSupplierStatus(e, item.supplier_id, item.status)} id={`statusbtn${i + 1}`} outline><span className={`fa fa-${btnIcon}`} /></Button>
                            <UncontrolledTooltip placement="bottom" target={`statusbtn${i + 1}`}>{statusText}</UncontrolledTooltip>

                            {/* Permanent Delete */}
                            <Button color="danger" className="btn-xs" onClick={e => this.updateSupplierStatus(e, item.supplier_id, 2)} id={`trashbtn${i + 1}`} outline><span className="fa fa-trash" /></Button>
                            <UncontrolledTooltip placement="bottom" target={`trashbtn${i + 1}`}>Permanent Delete</UncontrolledTooltip>
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="6">No data available..</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
              <FormGroup className={list === false || (realList.length / 10) <= 1 ? 'display-none' : ''}>
                <ReactPaginate
                    previousLabel="<<"
                    nextLabel=">>"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={realList.length / 10}
                    onPageChange={this.handleClick}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={2}
                    containerClassName="list-pagination"
                    activeClassName="active"
                />
              </FormGroup>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}
export default withTranslation('common')(SupplierLists);
